import { ReactElement, useState } from "react";

type Props = {
    title: string;
    content: ReactElement;
}

export const CommunityAdminSimpleAccordion = ({ title, content }: Props) => {
    const [show, setShow] = useState(false);
    return (
        <div className="admin-community-accordion">
            <div className="admin-community-accordion__header" onClick={() => setShow(prev => !prev)}>
                <span>{title}</span>

                <svg style={{ rotate: show? '0deg': '180deg' }} xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M0.530331 5.06055L4.53033 1.06055L8.53033 5.06055" stroke="#262626" stroke-width="1.5"/>
                </svg>
            </div>
            {show && (
                <p className="admin-community-accordion__content">
                    {content}
                </p>
            )}
        </div>
    )
}